// Copyright (c) 2019 Deere & Company

import { Component } from 'react';
import OktaStateStruct from '../state/okta-state';
import PropTypes from 'prop-types';
import { withAuth } from '@okta/okta-react';

class OktaState extends Component {

    async componentDidMount () {

        await this.checkAuthentication();

        if ( this.props.oktaState.isAuthenticated === null ) {

            setTimeout( () => {

                this.checkAuthentication();

            }, 2000 );

        }

        if ( !this.props.oktaState.userFirstName ) {

            await this.setUsername();

        }

        if ( !this.props.oktaState.accessToken ) {

            await this.setUserAccessToken();

        }

    }

    async componentDidUpdate ( prevProps ) {

        // console.log( 'Comp did update' );
        // console.log( prevProps );
        // console.log( this.props );
        if ( prevProps.oktaState.isAuthenticated !== this.props.oktaState.isAuthenticated ) {

            // console.log( 'ComponentDid Update - isAuth updated' );
            await this.checkAuthentication();
            await this.setUsername();
            await this.setUserAccessToken();

        }

    }

    async setUsername () {

        if ( this.props.oktaState.isAuthenticated ) {

            const user = await this.props.auth.getUser();
            this.props.actions.updateOktaUserFirstName( user.firstName );

        }

    }

    async setUserAccessToken () {

        if ( this.props.oktaState.isAuthenticated ) {

            const accessToken = await this.props.auth.getAccessToken();

            this.props.actions.updateOktaAccessToken( accessToken );

            // eslint-disable-next-line no-underscore-dangle
            const tok = await this.props.auth._oktaAuth.token.decode( accessToken );
            // console.log(tok);
            // tok.payload.iat  tok.payload.exp
            // console.log("Iat: "+tok.payload.iat);
            // console.log("Exp: "+tok.payload.iat);
            // const iat = new Date( tok.payload.iat * 1000 );
            const exp = new Date( tok.payload.exp * 1000 );
            const cur = new Date();
            // console.log("Date diff: "+(exp-cur));

            let renewTime = ( exp - cur - 25000 );

            if ( renewTime < 0 ) renewTime = 0;

            setTimeout( () => {

                this.updateAuthentication();

            }, ( renewTime ) );

        }

    }

    async checkAuthentication () {

        const isAuthenticated = await this.props.auth.isAuthenticated();

        if ( isAuthenticated !== this.props.oktaState.isAuthenticated ) {

            this.props.actions.updateOktaIsAuthenticated( isAuthenticated );

            if ( !this.props.oktaState.userFirstName ) {

                await this.setUsername();

            }

            if ( !this.props.oktaState.accessToken ) {

                await this.setUserAccessToken();

            }

        }

    }

    async updateAuthentication () {

        await this.checkAuthentication();
        await this.setUsername();
        await this.setUserAccessToken();

    }

    render () {

        return ( null );

    }

}

OktaState.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    oktaState: PropTypes.instanceOf( OktaStateStruct ).isRequired,
};

export default withAuth( OktaState );
